import * as React from 'react';

import {
  StackNavigationProp,
  createStackNavigator
} from '@react-navigation/stack';
import { getScreenOptions } from './getScreenOptions';
import MyProfileSettingsScreen from '../screens/my-profile/MyProfileSettingsScreen';
import MyProfileEditInfoScreen from '../screens/my-profile/MyProfileEditInfoScreen';
import MyProfileBiometricSettingsScreen from '../screens/my-profile/MyProfileBiometricSettingsScreen';
import MyProfileWearableSettingsScreen from '../screens/my-profile/MyProfileWearableSettingsScreen';
import MyProfileDataPrivacySettingsScreen from '../screens/my-profile/MyProfileDataPrivacySettingsScreen';
import MyProfileDeleteDataScreen from '../screens/my-profile/MyProfileDeleteDataScreen';
import { H5 } from '../components/Typography';
import { Octicons } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import elementIDs from '../../elementIDs';

export type MyProfileSettingsParamList = {
  MyProfileSettings: undefined;
  MyProfileEditInfo: {
    profileInfoType:
      | 'name'
      | 'email'
      | 'password'
      | 'birthDate'
      | 'state'
      | 'address'
      | 'phoneNumber'
      | 'notifyForMessages'
      | 'notifyForStudy'
      | 'unitSystem'
      | 'biologicalSex';
  };
  MyProfileBiometricSettings: undefined;
  MyProfileWearableSettings: undefined;
  MyProfileDataPrivacySettings: undefined;
  MyProfileDeleteData: undefined;
};

const MyProfileSettingsStack =
  createStackNavigator<MyProfileSettingsParamList>();

export default function MyProfileSettingsNavigator() {
  const navigation = useNavigation<StackNavigationProp<any>>();
  return (
    <MyProfileSettingsStack.Navigator
      initialRouteName='MyProfileSettings'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        headerStyle: {
          backgroundColor: '#FDFBF7',
          elevation: 0,
          shadowOpacity: 0,
          borderBottomWidth: 0
        },
        headerLeft: props => (
          <TouchableOpacity
            testID={elementIDs.profileSettingsBackID}
            style={{ marginLeft: 26, width: 30 }}
            onPress={() => {
              if (!props.canGoBack) {
                const parentNavigation = navigation?.getParent();
                if (!parentNavigation) return;
                const parentCanGoBack = parentNavigation.canGoBack();
                if (!parentCanGoBack) {
                  navigation.reset({
                    index: 0,
                    routes: [
                      {
                        name: 'StudiesNav'
                      }
                    ]
                  });
                } else {
                  parentNavigation.goBack();
                }
              } else {
                props.onPress?.();
              }
            }}
          >
            <Octicons size={30} name='chevron-left' />
          </TouchableOpacity>
        ),
        headerTitle: props => <H5 color='dark'>{props.children}</H5>,
        headerTitleAlign: 'center',
        headerShown: true,
        gestureEnabled: false
      })}
    >
      <MyProfileSettingsStack.Screen
        name='MyProfileSettings'
        component={MyProfileSettingsScreen}
        options={{
          title: 'Profile'
        }}
      />

      <MyProfileSettingsStack.Screen
        name='MyProfileEditInfo'
        component={MyProfileEditInfoScreen}
      />

      <MyProfileSettingsStack.Screen
        name='MyProfileBiometricSettings'
        component={MyProfileBiometricSettingsScreen}
        options={{
          title:
            Platform.OS === 'ios'
              ? 'Face / Touch ID'
              : 'Face / Fingerprint Biometric'
        }}
      />

      <MyProfileSettingsStack.Screen
        name='MyProfileWearableSettings'
        component={MyProfileWearableSettingsScreen}
        options={{ title: 'Wearable Integrations' }}
      />

      <MyProfileSettingsStack.Screen
        name='MyProfileDataPrivacySettings'
        component={MyProfileDataPrivacySettingsScreen}
        options={{ title: 'Data & Privacy' }}
      />

      <MyProfileSettingsStack.Screen
        name='MyProfileDeleteData'
        component={MyProfileDeleteDataScreen}
        options={{ title: 'Delete Account' }}
      />
    </MyProfileSettingsStack.Navigator>
  );
}
